module.exports = __webpack_public_path__ + "img/texture-road.eb09aaad.png";